import Cookies from "js-cookie";
import { setCookie } from "utils/StorageVariables";
import { ActionTypes } from "./types";
import { checkAuth } from "api";
import { IsUser } from "Redux/User/action";

async function getCheckAuthLocal() {
  return new Promise((resolve) => {
    setTimeout(() => {
      const rawData = Cookies.get('token-local');

      if (!rawData || typeof rawData === "undefined") {
        resolve({
          data: {
            authenticated: false
          }
        });

        return;
      }

      const data = JSON.parse(rawData);

      resolve({
        data: {
          authenticated: true,
          ...data
        }
      });
    }, 150); // Simulate response time
  });
}

export const CheckAuth = (params) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING, payload: params });

    const { data: results } = process.env.NODE_ENV === 'development'
      ? await getCheckAuthLocal()
      : await checkAuth();

    if (results) {
      const data = results.token && results.user
        ? results
        : process.env.NODE_ENV === 'development'
          ? { user: {} }
          : { token: '', user: {} };

      dispatch({
        type: ActionTypes.SUCCESS,
        payload: data
      });

      if (results.user) {
        setCookie("userDetail", JSON.stringify(results.user));
        dispatch(IsUser(results.user));
      }
    }
  } catch (error) {
    dispatch({
      type: ActionTypes.ERROR,
      payload: error
    });
  }
};

export const SetToken = token => async (dispatch) => {
  dispatch({
    type: ActionTypes.SET_TOKEN,
    payload: { token }
  });
};

export const RemoveToken = () => async (dispatch) => {
  dispatch({
    type: ActionTypes.REMOVE_TOKEN
  });
};
